<div class="animation-fade-in-right">
    <div class="grid">
        <div class="col-12 md:col-6">
            <div class="surface-card border-1 surface-border border-round p-4 mb-3 h-full">
                <span class="text-900 font-bold block mb-4 text-lg"><i class="pi pi-calendar mr-2"></i>Período y
                    Ubicación</span>

                <div class="field mb-4">
                    <label for="period" class="block text-900 font-medium mb-2">Período a exportar *</label>
                    <div class="flex gap-2">
                        <select class="w-full p-2 border-1 surface-border border-round text-900"
                            [(ngModel)]="selectedMonth" (ngModelChange)="selectedMonthChange.emit($event)">
                            <option value="01">Enero</option>
                            <option value="02">Febrero</option>
                            <option value="03">Marzo</option>
                            <option value="04">Abril</option>
                            <option value="05">Mayo</option>
                            <option value="06">Junio</option>
                            <option value="07">Julio</option>
                            <option value="08">Agosto</option>
                            <option value="09">Septiembre</option>
                            <option value="10">Octubre</option>
                            <option value="11">Noviembre</option>
                            <option value="12">Diciembre</option>
                        </select>

                        <select class="w-full p-2 border-1 surface-border border-round text-900"
                            [(ngModel)]="selectedYear" (ngModelChange)="selectedYearChange.emit($event)">
                            <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                        </select>
                    </div>
                </div>

                <div class="field mb-4">
                    <label class="block text-900 font-medium mb-2">Establecimiento</label>
                    <select class="w-full p-2 border-1 surface-border border-round text-900">
                        <option value="">Todos los establecimientos</option>
                        <option value="ALMACEN">Almacén Central</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="col-12 md:col-6">
            <div class="surface-card border-1 surface-border border-round p-4 mb-3 h-full">
                <span class="text-900 font-bold block mb-4 text-lg"><i class="pi pi-file mr-2"></i>Formato de
                    Exportación</span>
                <span class="block text-600 mb-3">Seleccione los formatos a generar</span>

                <div class="field checkbox-wrapper mb-4">
                    <div class="flex flex-column">
                        <label
                            class="flex align-items-start p-3 border-1 border-round cursor-pointer transition-colors transition-duration-200 mb-3"
                            [ngClass]="{'surface-border surface-card hover:surface-hover': !formatTxt, 'border-primary bg-blue-50': formatTxt}">
                            <div class="flex align-items-center mt-1 mr-3">
                                <p-checkbox [(ngModel)]="formatTxt" [binary]="true"></p-checkbox>
                            </div>
                            <div>
                                <span class="font-medium block text-900 mb-1">
                                    <i class="pi pi-file-o mr-2 text-primary"></i>Archivo de Texto (.txt)
                                </span>
                                <span class="text-sm text-600 line-height-3">Formato PLE delimitado por pipes (|) para
                                    carga directa en SUNAT</span>
                            </div>
                        </label>

                        <label
                            class="flex align-items-start p-3 border-1 border-round cursor-pointer transition-colors transition-duration-200"
                            [ngClass]="{'surface-border surface-card hover:surface-hover': !formatXls, 'border-primary bg-blue-50': formatXls}">
                            <div class="flex align-items-center mt-1 mr-3">
                                <p-checkbox [(ngModel)]="formatXls" [binary]="true"></p-checkbox>
                            </div>
                            <div>
                                <span class="font-medium block text-900 mb-1">
                                    <i class="pi pi-chart-bar mr-2 text-green-500"></i>Archivo Excel (.xlsx)
                                </span>
                                <span class="text-sm text-600 line-height-3">Formato estructurado en columnas para
                                    revisión y análisis</span>
                            </div>
                        </label>
                    </div>
                </div>

                <div class="bg-blue-50 text-blue-700 p-3 border-round border-blue-100 flex align-items-start">
                    <i class="pi pi-info-circle mr-3 mt-1 text-xl"></i>
                    <div>
                        <span class="font-bold block mb-1">Nomenclatura del archivo TXT</span>
                        <span class="block text-sm mb-1">El archivo seguirá el formato:</span>
                        <span class="font-mono font-bold text-sm block">LE[RUC][AAAAMM]00130100001111.txt</span>
                        <span class="text-sm">Según especificaciones del PLE SUNAT</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="flex justify-content-end pt-3 border-top-1 surface-border">
        <button pButton label="Aceptar" icon="pi pi-check" iconPos="right" [loading]="isLoading"
            (click)="onNext()"></button>
    </div>
</div>